import { useParams } from 'react-router-dom'

import HappierHealthierYouForm from './ServiceForms/HappierHealthierYouForm'
import PreparingParentsForm from './ServiceForms/PreparingParentsForm'
import PupilCounsellingForm from './ServiceForms/PupilCounsellingForm'
import PhysiotherapyForm from './ServiceForms/PhysiotherapyForm'
import NurseSupportForm from './ServiceForms/NurseSupportForm'
import MindfulnessForm from './ServiceForms/MindfulnessForm'
import CounsellingForm from './ServiceForms/CounsellingForm'
import RelaxationForm from './ServiceForms/RelaxationForm'
import PupilYogaForm from './ServiceForms/PupilYogaForm'
import ManspaceForm from './ServiceForms/ManspaceForm'
import AwardsForm from './ServiceForms/AwardsForm'
import SasGymForm from './ServiceForms/SasGymForm'
import MenopauseSupportForm from './ServiceForms/MenopauseSupportForm'
import FoodIntoleranceTestingForm from './ServiceForms/FoodIntoleranceTestingForm'
import FinancialWellbeingForm from './ServiceForms/FinancialWellbeingForm'

const ServicePage = () => {
  const { serviceKey } = useParams()

  const FormComponent = () => {
    switch (serviceKey) {
      //Mental Health
      case 'counselling':
        return <CounsellingForm />
      case 'mindfulness':
        return <MindfulnessForm />
      case 'relaxation':
        return <RelaxationForm />

      // Health Line
      case 'nurse-support':
        return <NurseSupportForm />
      case 'menopause-support':
        return <MenopauseSupportForm />

      // Physical Health
      case 'sas-gym':
        return <SasGymForm />
      case 'hhy':
        return <HappierHealthierYouForm />
      case 'physiotherapy':
        return <PhysiotherapyForm />

      // General Health

      case 'preparing-parents':
        return <PreparingParentsForm />
      case 'manspace':
        return <ManspaceForm />
      case 'food-intolerance-testing':
        return <FoodIntoleranceTestingForm />
      case 'financial-wellbeing':
        return <FinancialWellbeingForm />

      // Pupil Wellbeing
      case 'pupil-yoga':
        return <PupilYogaForm />
      case 'pastoral-resources':
        return <PupilCounsellingForm />

      // Leadership Support
      case 'awards':
        return <AwardsForm />

      default:
        return (
          <div className="max-w-2xl mx-auto p-6 space-y-8 text-portal-dark-blue">
            <h1 className="text-[#41264B] text-2xl font-semibold border-b border-[#41264B]">
              Service Not Found
            </h1>
            <p>The requested service form could not be found.</p>
          </div>
        )
    }
  }

  return (
    <section>
      <FormComponent />
    </section>
  )
}

export default ServicePage
